:host {
  display: table-row;
  border: 1px solid var(--sc-table-row-border-bottom-color, var(--sc-color-gray-200));
}
:host([href]) {
  cursor: pointer;
}
:host([href]:hover) {
  background: var(--sc-color-gray-50);
}
